import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import "./style.scss";

interface InputProps {
    type?: string;
    placeholder?: string;
    value?: string;
    showSearch?: boolean;
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
    clearValue?: boolean;
    name: string;
    onEnterKeyPress?: () => void;
    onChange?: (value: string) => void;
    onSearch?: (val?: string) => void;
    customSearchText?: string;
    customSearchIcon?: React.ReactNode;
    autoFocus?: boolean;
}

const Input = (props: InputProps) => {
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    const onTextChange = (value: string) => {
        if (props.onChange) {
            props.onChange(value);
        }
    };

    const onKeyPress = (e: any) => {
        if (e.key === "Enter" && props.onEnterKeyPress && !props.showSearch) {
            props.onEnterKeyPress();
        }
        if (props.showSearch && e.key === "Enter" && props.onSearch) {
            props.onSearch(value);
        }
    };

    return (
        <div className="vapor-input-wrapper">
            {props.prefix && (
                <div className="vapor-input-prefix">{props.prefix}</div>
            )}
            <input
                autoFocus={props.autoFocus}
                id={props.name}
                key={props.name}
                defaultValue={props.value}
                className={
                    "vapor-input" +
                    (props.showSearch || props.suffix ? " withSuffix" : "") +
                    (props.prefix ? " withPrefix" : "") +
                    (props.showSearch ? " withSearch" : "")
                }
                onBlur={(e) => {
                    onTextChange(e.target.value);
                }}
                onChange={(e) => setValue(e.target.value)}
                onKeyPress={(e) => onKeyPress(e)}
                type={props.type || "text"}
                placeholder={props.placeholder}
                value={value}
            />
            {props.showSearch && (
                <div
                    onMouseDown={() => {
                        if (props.onSearch) {
                            props.onSearch(value);
                        }
                    }}
                    className={`vapor-input-suffix vapor-input-search-btn ${
                        props.customSearchText ? " search-btn-large" : ""
                    }`}
                >
                    {props.customSearchText ? (
                        props.customSearchText
                    ) : props.customSearchIcon ? (
                        props.customSearchIcon
                    ) : (
                        <FontAwesomeIcon icon={["far", "search"]} />
                    )}
                </div>
            )}
            {(props.showSearch || props.clearValue) && props.value !== "" && (
                <div
                    id={props.name + "_clear"}
                    className={
                        "vapor-input-clear-value" +
                        (props.showSearch
                            ? ` withSearch${props.customSearchText ? " search-btn-large" : ""}`
                            : "")
                    }
                    onMouseDown={() => onTextChange("")}
                >
                    <FontAwesomeIcon icon={["fas", "times-circle"]} />
                </div>
            )}
            {!props.showSearch && props.suffix && (
                <div className="vapor-input-suffix">{props.suffix}</div>
            )}
        </div>
    );
};

Input.defaultProps = {
    showSearch: false,
    clearValue: false,
};

export default Input;
